<template>
    <div class="xgcsz">
        <easyCruds ref="mainTable" :tableInfo="mainTable"
                @mainTableReload="mainTableReload"
                @deleteRows="deleteRows"
                @cpdlChange="cpdlChange"
                @addData="addData"
                @editsRow="editsRow"
                @fabu="fabu"
                @viewRow="viewRow"
                @resrt="resrt">
        </easyCruds>
        
        <!-- 新增弹框 -->
        <el-dialog
        :title="titDialog"
        :visible.sync="dialogVisible"
        width="50%"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        >
        <el-steps :active="step" finish-status="success" simple>
            <el-step title="步骤 1"></el-step>
            <el-step title="步骤 2"></el-step>
            <el-step title="步骤 3"></el-step>
        </el-steps>

        <avue-form ref="addDialog1" v-model="addData1" :option="addOption1" v-if="step===0"></avue-form>
        <keep-alive>
            <avue-form ref="addDialog2" v-model="addData2" :option="addOption2" v-if="step===1&&addData1.fdj===2"></avue-form>
        </keep-alive>
        <avue-form ref="addDialog21" v-model="addData21" :option="addOption21" v-if="step===1&&addData1.fdj===1"></avue-form>
        <template v-if="step>1">
            <div>
                <el-table
                    :row-class-name="tableRowClassName"
                    :data="addData3"
                    border
                    :show-summary="hjflag"
                    :span-method="objectSpanMethod"
                    :summary-method="getSummaries"
                    style="width: 100%; margin-top: 20px">
                    <el-table-column
                        v-if="addData1.fdj===2"
                        prop="cp_dj_id"
                        label="参评等级"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="xymc"
                        label="学院名称">
                    </el-table-column>
                    <el-table-column
                        prop="count"
                        label="学院总人数">
                    </el-table-column>
                    <el-table-column
                        prop="cpnum"
                        label="参考人数">
                    </el-table-column>
                    <el-table-column
                        prop="num"
                        label="调整人数">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.cpnum2" placeholder="请输入调整人数" :disabled="viewflag" @input="changeCpnum"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                </div>
            </template>

        <span slot="footer" class="dialog-footer">
            <el-button @click="addCancel">取 消</el-button>
            <el-button @click="previous" v-if="step">上一步</el-button>
            <el-button type="primary" @click="nextOrSave" v-html="step<2?'下一步':'保存'"></el-button>
        </span>
        </el-dialog>

        <!-- 发布弹框 -->
        <el-dialog
            title="提示"
            :visible.sync="fabuVisible"
            width="40%"
            append-to-body
            >
            <avue-form ref="fabuform" v-model="fabuData" :option="fabuoption"></avue-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="fabuVisible = false">取 消</el-button>
                <el-button type="primary" @click="fabuConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
             var checkNum = (rule, value, callback) => {
                if (!value && value!=0) {
                return callback(new Error('不能为空'));
                }
                if (!Number.isInteger(value)) {
                    callback(new Error('请输入数字值'));
                } else {
                    if ( value < 0) {
                    callback(new Error('不能小于0'));
                    } else {
                    callback();
                    }
                }
            };
            return {
                titDialog:"新增",
                fabuVisible:false,
                fabuId:null,
                hjflag:true,
                dialogVisible: false,
                viewflag:false,
                step:0,
                id:null,
                cpxxFpMap:null,
                fabuData:{},
                fabuoption:{
                    emptyBtn:false,
                    submitBtn:false,
                    column:[
                        {
                            label:'开始时间',
                            prop:"kssj",
                            type:"date",
                            format:"yyyy-MM-dd",
                            valueFormat:'yyyy-MM-dd',
                            span:12,
                        },
                        {
                            label:'结束时间',
                            prop:"jssj",
                            type:"date",
                            format:"yyyy-MM-dd",
                            valueFormat:'yyyy-MM-dd',
                            span:12,

                        }
                    ]
                },

                addData1:{
                    fdj:1,
                    abl:1
                },
                addData2:{},
                addData21:{},
                addData3:[],
                spanArr: [],

                addOption1:{
                    emptyBtn:false,
                    submitBtn:false,
                    labelWidth:120,
                    disabled:true,

                    column:[
                        {
                            label:"参评大类",
                            prop:"cpdl_id",
                            type:"select",
                            disabled:false,
                            rules: [
                                {
                                    required: true,
                                    message: "请选择参评大类名称",
                                    trigger: "change"
                                }
                            ],
                            dicData:[], 
                            change:(e)=>{      
                            //    参评名称
                                if(e.value){
                                     this.$http.get('/cplb/listByCpdl_id', {params:{
                                        cpdl_id:e.value
                                    }}).then(response => {
                                        // console.log(response);
                                        let arrDate = []
                                        let column=this.addOption1.column
                                        response.data.forEach(element => {
                                            arrDate.push({
                                                label: element.lbmc,
                                                value: element.id
                                            })
                                        })
                                        // console.log(arrDate)
                                        let index = this.findArray(column,"cplb_id",'prop');
                                        column[index].dicData=arrDate;
                                    })
                                }
                            }
                        },
                        {
                            label:"参评类别名称",
                            prop:"cplb_id",
                            type:"select",
                            dicData:[],
                            rules: [{
                                required: true,
                                message: "请选择参评类别名称",
                                trigger: "change"
                            }]
                        },
                        {
                            label:"参评名称",
                            prop:"cp_mc",
                            rules: [{
                                required: true,
                                message: "请输入参评名称",
                                trigger: "blur"
                            }]
                        },
                        {
                            label:"参评学年",
                            prop:"xn",
                            type:"select",
                            rules: [{
                                required: true,
                                message: "请输入参评学年",
                                trigger: "change"
                            }],
                            change:(e)=>{
                                // 增加弹框-互斥参评
                                // console.log(e);
                                if(e.value){

                                        this.$http.get("/cpxx/list",{
                                            params:{
                                                xn:e.value
                                            }
                                        }).then(res=>{
                                        let arrDate=[]; 
                                        let column=this.addOption1.column;
                                        let index = this.findArray(column,"hc_cp_id",'prop');
                                        res.data.forEach(element=>{
                                            arrDate.push({
                                                label:element.cp_mc,
                                                value:element.id.toString()
                                            })
                                        });
                                        arrDate=arrDate.sort(this.sortBy('label',false));
                                        column[index].dicData=arrDate;
                                    });
                                }
                            }
                        },
                        {
                            label:"参评学期",
                            prop:"xq",
                            type:"select",
                            dicData:[
                                {
                                    label:"第一学期",
                                    value:1
                                },
                                {
                                    label:"第二学期",
                                    value:2
                                }
                            ]
                        },
                        {
                            label:"参评班级",
                            prop:"bj_type",
                            type:"select",
                            rules: [{
                                required: true,
                                message: "请选择参评班级",
                                trigger: "change"
                            }],
                            dicData:[
                                {
                                    label:"原班级",
                                    value:1
                                },
                                {
                                    label:"现班级",
                                    value:2
                                }
                            ]
                        },
                        {
                            label:"互斥参评",
                            prop:"hc_cp_id",
                            type:"select",
                            multiple:true,
                            dataType:"string",
                            dicData:[]
                        },
                        {
                            label:"描述",
                            prop:"ms",
                            type:"textarea",
                            span:24,
                            minRows:4,
                            maxRows:4,
                        },
                        {
                            label:"等级",
                            prop:"fdj",
                            type:"radio",
                            dicData:[
                                {
                                    label:"不分等级",
                                    value:1
                                },
                                {
                                    label:"分等级",
                                    value:2
                                }
                            ]
                        },
                        {
                            label:"人数比例",
                            prop:"abl",
                            type:"radio",
                            dicData:[
                                {
                                    label:"固定人数",
                                    value:1
                                },
                                {
                                    label:"固定比例",
                                    value:2
                                }
                            ]
                        }
                    ]
                },
                // 分等级
                addOption2:{
                    emptyBtn:false,
                    submitBtn:false,
                    column:[
                        {
                            label:"详情设置",
                            prop:"dynamic",
                            type:"dynamic",
                            span:24,
                            row: true,      
                             children: {
                                align: 'center',
                                headerAlign: 'center',
                                rowAdd:(done)=>{
                                    console.log(this.addData2);
                                    let num = this.addData2.dynamic.length;
                                    let arrNum = ['一','二','三','四','五','六','七','八','九','十'];
                                    arrNum.forEach((e,i)=>{
                                        if(num===i){
                                            num=e
                                        }
                                    })
                                    // console.log(num);
                                    done({
                                        dj:num+'等'
                                    });
                                },
                                 rowDel:(row,done)=>{
                                     console.log(row)
                                     console.log(this.addData2.dynamic.length)
                                     if(row.$index===(this.addData2.dynamic.length-1)){
                                        done();
                                     }else{
                                         this.$message.warning('请删除最后一个')
                                     }
                                    // this.$message.success('删除回调'+JSON.stringify(row));
                                },
                                column:[
                                    {
                                        label:"参评等级",
                                        prop:"dj",
                                        readonly:true,
                                    },
                                    {
                                        label:"参评人数(或比例)",
                                        type:"number",
                                        prop:"cpnum",
                                        rules:[
                                            {validator:checkNum, trigger: 'blur' }
                                        ]
                                        
                                    },
                                    {
                                        label:"参评金额(元/人)",
                                        prop:"cpje",
                                        type:"number",
                                        rules:[
                                            {validator:checkNum, trigger: 'blur' }
                                        ]
                                    },
                                    {
                                        label:"资格限定器",
                                        prop:"zgxdq_id",
                                        type:"select",
                                        dicData:[]
                                    }
                                ]
                             }
                        }
                    ]
                },
                // 不分等级
                addOption21:{
                    emptyBtn:false,
                    submitBtn:false,
                    labelWidth:150,
                    column:[
                        {
                            label:"分配名额(或比例%)",
                            prop:"cpnum",
                            span:12,
                            type:"number",
                            rules:[
                                {validator:checkNum, trigger: 'blur' }
                            ]
                        },
                        {
                            label:"参评金额(元/人)",
                            prop:"cpje",
                            span:12,
                            type:"number",
                            rules:[
                                {validator:checkNum, trigger: 'blur' }
                            ]

                            
                        },
                        {
                            label:"资格限定器",
                            prop:"zgxdq_id",
                            span:12,
                            type:"select",
                            dicData:[]

                        }
                    ]
                },

                mainTable: {
                    buttonSetting: {
                        resetFunctionName:'resrt',
                        editFunctionName: 'editRow',
                        deleteFunctionName: 'deleteRows',
                        allowAdd: false,
                        allowEdit: false,
                        editButtonArray:[{
                            clickEvent:'editRow',
                            type:'primary',
                            buttonName:'保存编辑',
                            validate: true
                        }],

                        allowDelete: true,
                        allowView: false,
                        
                        left: [{
                            title: '新增',
                            type: 'primary',
                            clickEvent: 'addData',
                            icon:"el-icon-plus"
                        }]
                    },
                    header: {
                        title: '学工处发布列表'
                    },
                    table: {
                        loading: false,
                        height: 550,
                        stripe: true,
                        conditionLabelWidth: 'auto',
                        selection: true,
                        index: true,
                        dialogLabelWidth:"160px",
                        columns: [
                            {
                                prop:"cpdl_mc",
                                label:"参评大类",
                                type:"select",
                                isSearchCondition: true,
                                searchChangeFunction: 'cpdlChange',//参评大类触发事件
                                required: true,
                                dicData:[],
                                onChange: (item, value, cpmpution) => {
                                    console.log(item);
                                if (!value) return
                                this.cpdlChange({ value }, null, (dicData) => {
                                        cpmpution.form.formItems.forEach(ele => {
                                            if (ele.prop === 'cplb_mc') {
                                                // console.log(ele);
                                                this.$set(ele, 'dicData', dicData)
                                            }
                                        })
                                    })
                                },
                            },
                            {
                                prop:"cplb_mc",
                                label:"参评类别名称",
                                type:"select",
                                isSearchCondition: true,
                                dicData:[],
                                required: true,
                            },
                            {
                                prop:"cp_mc",
                                label:"参评名称",
                                isSearchCondition: true,
                                required: true,
                            },
                            {
                                prop:"bj_type",
                                label:"参评班级",
                                type:"select",
                                required: true,
                                dicData:[
                                    {
                                        label:"原班级",
                                        value:1
                                    },
                                    {
                                        label:"现班级",
                                        value:2
                                    }
                                ],
                                dataFilter:(value) =>{
                                    if(value===1){
                                        return "原班级"
                                    }
                                    if(value===2){
                                        return "现班级"
                                    }
                                }
                            },
                            {
                                prop:"xn",
                                label:"参评学年",
                                type:"select",
                                dicData:[],
                                isSearchCondition: true,
                                required: true,
                            },
                            {
                                prop:"xq",
                                label:"参评学期",
                                type:"select",
                                dicData:[
                                    {
                                        label:"第一学期",
                                        value:1
                                    },
                                    {
                                        label:"第二学期",
                                        value:2
                                    }
                                ],
                                dataFilter:(value) =>{
                                    if(value===1){
                                        return "第一学期"
                                    }
                                    if(value===2){
                                        return "第二学期"
                                    }
                                }
                            },
                            // {
                            //     prop:"num",
                            //     label:"参评人数",
                            //     view:[false,false,false]
                            // },
                            {
                                prop:"kssj",
                                label:"参评开始时间",
                                type:"date",
                                format:'yyyy-MM-dd',
                                dataFilter:function(value){
                                    if (value)
                                    return (value.toString().split("T")[0]);
                                },
                                view:[false,false,false]
                            },
                            {
                                prop:"jssj",
                                label:"参评结束时间",
                                type:"date",
                                format:'yyyy-MM-dd',
                                dataFilter:function(value){
                                    if (value)
                                    return (value.toString().split("T")[0]);
                                },
                                view:[false,false,false]
                            },
                            {
                                prop:"zt",
                                label:"状态",
                                type:"select",
                                isSearchCondition: true,
                                view:[false,false,false],
                                dataFilter:(value) =>{
                                    if(value===1){
                                        return "未发布"
                                    }
                                    if(value===2){
                                        return "已发布"
                                    }
                                },
                                dicData:[
                                    {
                                        label:'未发布',
                                        value:1
                                    },
                                    {
                                        label:'已发布',
                                        value:2
                                    }
                                ]
                            }
                        ],
                        operation: {
                            width: '220',
                            operations: [{
                                title: function(params) {
                                    if (params.zt === 1) {
                                    return '发布'
                                    } else {
                                    return '取消发布'
                                    }
                                },
                                clickEvent: 'fabu',   
                                color: '#7acfa6'
                                },
                                {
                                    title: function(params) {
                                        return '编辑'
                                    },
                                    clickEvent: 'editsRow',   
                                    color: '#9f8bea',
                                },
                                {
                                    title: function(params) {
                                        return '查看'
                                    },
                                    clickEvent: 'viewRow',   
                                    color: '#9f8bea'
                                },
                            ]
                        },
                        tableData: [],
                        paging: {
                            currentPage: 1,
                            pageSizes: [10, 15, 20, 25],
                            pageSize: 10,
                            total: 0
                        },
                        reload: 'mainTableReload',
                        reloadConditions: {},
                        addDefultValue: {}
                    }

                }
            }
        },
        methods: {
            changeCpnum(){
                let getSum = (total,num)=>{
                    return total + num
                };
                let getDjData=(dj,djmc)=>{  
                    let djdata=this.addData3.filter(e=>{
                        return e.dj===dj
                    })
                    djdata=this.validatenull(djdata)?0:djdata.map(e=>{
                        return e.cpnum2*1
                    }).reduce(getSum);
                    this.addData3.forEach(e=>{
                        if(e.cp_dj_id===djmc&e.xymc==='合计'){
                            e.cpnum2=djdata
                        }
                    })
                };
                getDjData(0,'一等');
                getDjData(1,'二等');
                getDjData(2,'三等');
                getDjData(3,'四等');
                getDjData(4,'五等');
                getDjData(5,'六等');
                getDjData(6,'七等');
                getDjData(7,'八等');
                getDjData(8,'九等');
            },
             mainTableReload(params){
                params = params || {}
                this.mainTable.table.loading = true
                if (!params.pageSize) { params.pageSize = 10 }
                if (!params.pageNum) { params.pageNum = 1 }
                params.cpdl_id=params.cpdl_mc
                params.cplb_id=params.cplb_mc

                delete params.cpdl_mc
                delete params.cplb_mc
                this.$http.get('/cpxx/query', { params }).then(
                    res => {
                        // console.log(params)
                        this.mainTable.table.loading = false;
                        this.mainTable.table.tableData = res.data.records
                        this.mainTable.table.paging.total = res.data.total || res.data.records.length
                    }
                ).catch(
                    error => {
                    this.mainTable.table.loading = false;
                    this.$message.error(error.msg)
                    }
                )
            },
            // beforeAddFunctionName(){},
            beforeEditFunctionName(row,type,callback){
                callback();
            },

            // 查看
            viewRow(index,row){
                let column1=this.addOption1.column;
                let column2=this.addOption2.column;
                let column21=this.addOption21.column;
                this.viewflag=true;
                column1.forEach(e=>{
                    this.$set(e,"disabled",true)
                })
                column2.forEach(e=>{
                    this.$set(e,"disabled",true)
                })
                column21.forEach(e=>{
                    this.$set(e,"disabled",true)
                })
                this.titDialog="查看";
                this.view(row);
            },

            // 打开发布弹框
            fabu(index,row){
                this.fabuData.kssj=this.$options.data().fabuData.kssj;
                this.fabuData.jssj=this.$options.data().fabuData.jssj;

                // 打开发布弹框
                this.fabuId=row.id;
                if(row.zt===1){
                    this.fabuVisible=true;                   
                }
                // 打开取消发布弹窗
                if(row.zt===2){
                    this.$confirm('是否取消发布?', '取消发布', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.$http.post("/cpxx/unpublish",null,{
                            params:{
                                id:this.fabuId
                            }
                        }).then(res=>{
                            this.mainTableReload(this.$refs.mainTable.getReloadConditions());                      
                            this.$message({
                                type: 'success',
                                message: '取消发布成功!'
                            });
                        }).catch(error=>{
                            this.$message.error(error.msg);
                        })     
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '未改变操作'
                        });          
                    });
                }
            },
            // 确认发布
            fabuConfirm(){
                // console.log('确认发布');
                if(this.fabuData.kssj&&this.fabuData.jssj){
                    this.$http.post("/cpxx/publish",null,{
                        params:{
                            id:this.fabuId,
                            kssj:this.fabuData.kssj,
                            jssj:this.fabuData.jssj
                        }
                    }).then(res=>{
                        // console.log(res)
                        this.fabuVisible=false;
                        this.mainTableReload(this.$refs.mainTable.getReloadConditions());                      
                    }).catch(error=>{
                        this.$message.error(error.msg)
                    })
                }else{
                        this.$message.warning('必须选择 开始时间 以及 结束时间')

                }
                
            },
            // 编辑
            editsRow(index,row){
                let column1=this.addOption1.column;
                let column2=this.addOption2.column;
                let column21=this.addOption21.column;
                this.viewflag=false;
                column1.forEach(e=>{
                    this.$set(e,"disabled",false)
                })
                column2.forEach(e=>{
                    this.$set(e,"disabled",false)
                })
                column21.forEach(e=>{
                    this.$set(e,"disabled",false)
                })
                
                if(row.zt===2){
                    this.$message.warning('已发布,不可编辑')
                }else{
                    this.titDialog="编辑";
                    this.view(row);
                }
                
            },

            view(row){
                let column=this.addOption1.column;
                let i=this.findArray(column,"cpdl_id",'prop');
                this.$set(column[i],'disabled',true);
                this.step=this.$options.data().step
                this.spanArr=this.$options.data().spanArr;
                this.addData1=row;
                this.id=row.id;
                this.dialogVisible=true;
                this.$http.get("/cpxx/get",{
                    params:{
                        id:row.id
                    }
                }).then(res=>{
                    console.log(res.data.cpxxFpMap);
                    this.addData1=res.data;
                    this.cpxxFpMap=res.data.cpxxFpMap;
                    if(row.fdj===1){ 
                    //   不分等级
                        this.hjflag=true;

                        this.addData21=res.data.cpxxDjs[0]                      
                    }
                    if(row.fdj===2){
                         this.hjflag=false;

                        this.addData2.dynamic=res.data.cpxxDjs;
                    }
                }).catch(error=>{
                    this.$message.error(error.msg);
                })
            },

            // 删除
            deleteRows(deleteList){
                console.log(deleteList);
                
                deleteList.forEach(e=>{
                    if(e.zt===2){
                         this.$message.warning("已发布,不可删除!");
                    }else{
                        this.$http.post("/cpxx/delete",null,{   
                            params:{
                                id:e.id
                            }
                        }).then(res=>{
                            this.$message.success('删除成功');
                            this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                        }).catch(error=>{
                            this.$message.error(error.msg);
                        })
                    }
                })
                

                    
                
                
            },
            resrt(){},         
            // 表格相同数据列合并
             objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                
                if(this.addData1.fdj===2){
                    if(columnIndex ===0){
                        if(this.spanArr[rowIndex]){
                            return {
                                rowspan:this.spanArr[rowIndex],
                                colspan:1
                            }
                        }else{
                            return {
                                rowspan: 0,
                                colspan: 0
                            }
                        }
                    }
                }
                 

                
            },
            // 新增数据
            addData(){

                    let column=this.addOption1.column;
                    let i=this.findArray(column,"cpdl_id",'prop');
                    let hcindex=this.findArray(column,"hc_cp_id",'prop');
                    this.$set(column[i],'disabled',false);
                    this.dialogVisible=true;
                    this.titDialog="新增";
                    this.step=this.$options.data().step
                    this.objInit(this.addData1,this.$options.data().addData1)
                    this.objInit(this.addData2,this.$options.data().addData2)
                    this.objInit(this.addData21,this.$options.data().addData21)
                    
                   
                    column[hcindex].dicData=[];
                    // this.$set(this, column[hcindex], []);
                    this.spanArr=this.$options.data().spanArr;
                    this.id=null;
    
                    let column1=this.addOption1.column;
                    let column2=this.addOption2.column;
                    let column21=this.addOption21.column;
                    this.viewflag=false;
                    column1.forEach(e=>{
                        this.$set(e,"disabled",false)
                    })
                    column2.forEach(e=>{
                        this.$set(e,"disabled",false)
                    })
                    column21.forEach(e=>{
                        this.$set(e,"disabled",false)
                    })
            },

        
            // 新增下一步或完成
            nextOrSave(){
                 if (this.step++ > 1){
                     if(this.viewflag){
                         this.dialogVisible=false; 
                     }
                     this.step=this.$options.data().step;
                     let hc_cp_id=this.addData1.hc_cp_id;
                     if(typeof(hc_cp_id) ==="object"){
                         hc_cp_id="";
                     }
                     
      
                    //  不分等级

                     if(this.addData1.fdj===1&&!this.viewflag){
                         this.$nextTick(()=>{

                             console.log('不分等级,保存')
                             this.hjflag=true;
                             let cpxxFpMap=this.addData3.map(e=>{
                                 return {
                                     "num": e.cpnum2,
                                    "xydm": e.xydm
                                 }
                             })
                             cpxxFpMap=cpxxFpMap.filter(e=>{
                                return e.xydm!=null
                             })
                             let fuc=()=>{
                                  this.$http.post("/cpxx/addOrUpdate",
                                        {
                                            "id":this.id,
                                            "cpdl_id": this.addData1.cpdl_id,
                                            "cplb_id": this.addData1.cplb_id,
                                            "cpxxDjs": [
                                                {
                                                    "dj": 0,
                                                    "cpje": this.addData21.cpje,
                                                    "cpnum": this.addData21.cpnum,
                                                    "zgxdq_id":this.addData21.zgxdq_id
                                                }
                                            ],
                                            "cpxxFpMap": {
                                                "0": cpxxFpMap
                                            },
                                            "cp_mc": this.addData1.cp_mc,
                                            "xn": this.addData1.xn,
                                            "xq": this.addData1.xq,
                                            "hc_cp_id":hc_cp_id,
                                            "bj_type": this.addData1.bj_type,
                                            "fdj": this.addData1.fdj,
                                            "abl": this.addData1.abl,
                                            "ms": this.addData1.ms
                                        }
                                     ).then(res=>{
                                       this.dialogVisible=false;   
                                       this.mainTableReload(this.$refs.mainTable.getReloadConditions());                      
                                     }).catch(error=>{
                                         this.$message.error(error.msg);
                                     })
                             }
                             if(this.addData21.cpnum*1 >= 0 && this.addData21.cpje*1 >= 0){
                                 if(this.addData1.abl===2&&this.addData21.cpnum*1<=100){
                                    //  console.log(this.addData3);
                                     let flag=this.addData3.some(e=>{
                                         return e.cpnum2>e.count
                                     })
                                     !flag?fuc():this.$message.warning('调整参评人数不能超过学院人数');
                                 }else if(this.addData1.abl===2&&this.addData21.cpnum>100){
                                     this.$message.warning('参评比例不能超过100%')
                                 }else if(this.addData1.abl===1){
                                     let flag=this.addData3.some(e=>{
                                         return e.cpnum2>e.count
                                     })
                                     !flag?fuc():this.$message.warning('调整参评人数不能超过学院人数');
                                 }else{
                                     fuc();
                                 }
                             }else{
                                 this.$message.warning('参评人数 及 参评金额必须大于或等于0');
                             }
                         })
                     }
                    //  分等级

                    if(this.addData1.fdj===2&&!this.viewflag){
                        this.$nextTick(()=>{

                            this.hjflag=false;
                            let temps=[];
                            for(let i=0;i<this.addData2.dynamic.length;i++){
                                let index = this.addData2.dynamic[i].$index;
                                let temp = this.addData3.filter((e,i)=>{
                                    return e.dj===index
                                })
                                temp=temp.map(e=>{
                                    return {
                                        "num": e.cpnum2,
                                        "xydm": e.xydm
                                    }
                                })
                                temp=temp.filter(e=>{
                                   return e.xydm!=null
                                })
                                if(temp.length){
                                    temps.push(temp)
                                }
                            }
                            let cpxxFpMap={};
                            temps.forEach((e,i)=>{
                                cpxxFpMap[i+1]=e
                            }) 
                            let cpxxDjs=this.addData2.dynamic.map(e=>{
                                return {
                                    dj:e.$index+1,
                                    cpje:e.cpje,
                                    cpnum:e.cpnum,
                                    zgxdq_id:e.zgxdq_id
                                }
                            })
                            let fuc=()=>{
                                this.$http.post("/cpxx/addOrUpdate",
                                     {
                                         "id":this.id,
                                         "cpdl_id": this.addData1.cpdl_id,
                                         "cplb_id": this.addData1.cplb_id,
                                         "cpxxDjs": cpxxDjs,
                                         "cpxxFpMap": cpxxFpMap,
                                         "cp_mc": this.addData1.cp_mc,
                                         "xn": this.addData1.xn,
                                         "xq": this.addData1.xq,
                                         "hc_cp_id": hc_cp_id,
                                         "bj_type": this.addData1.bj_type,
                                         "fdj": this.addData1.fdj,
                                         "abl": this.addData1.abl,
                                         "ms": this.addData1.ms
                                     }
                                  ).then(res=>{
                                    this.dialogVisible=false;   
                                    this.mainTableReload()                        
                                  }).catch(error=>{
                                      this.$message.error(error.msg);
                                     this.spanArr=this.$options.data().spanArr;
         
                                  })
                            }
                            let cpFlag=this.addData2.dynamic.some(e=>{
                                return e.cpnum*1<0 && e.cpje*1<0
                            })
                            let bfb=this.addData2.dynamic.some(e=>{
                                return e.cpnum>100
                            })
    
                             if(!cpFlag){
                                 if(this.addData1.abl===2&&!bfb){
                                     let flag=this.addData3.some(e=>{
                                         return e.cpnum2>e.count
                                     })
                                     !flag?fuc():this.$message.warning('调整参评人数不能超过学院人数');
                                 }else if(this.addData1.abl===2&&bfb){
                                     this.$message.warning('参评比例不能超过100%')
                                 }else{
                                     fuc();
                                 }
                             }else{
                                 this.$message.warning('参评人数及 参评金额必须大于0')
                             }
                        })
                         
                    }
                }
                // 第三步数据带入-院校人数
                
                if(this.step>1){
                    if(this.addData1.fdj===1){
                        this.hjflag=true
                    }else{
                        this.hjflag=false
                    }
        
                    this.$http.post("/cpxx/countXyNum",null,{
                        params:{
                            bj_type:this.addData1.bj_type,
                            xn:this.addData1.xn
                        }
                    }).then(res=>{
                        console.log(this.cpxxFpMap)
                            let fpMap={};
                            if(!this.validatenull(this.cpxxFpMap)){
                                this.cpxxFpMap[0].forEach(e=>{
                                    fpMap[e.xydm]=e.num;
                                })
                            }                      
                        if(this.addData1.abl===2){      
                            this.addData3=res.data.map(e=>{
                                let cpnums=fpMap[e.xydm];
                                e.cpnum=Math.floor(e.count*this.addData21.cpnum*0.01)
                                if(cpnums!=undefined){
                                    e.cpnum2=cpnums
                                }else{
                                    e.cpnum2=e.cpnum;
                                }
                                return e
                            })
                        
                        }
                        if(this.addData1.abl===1){
                            let sum=0;
                            res.data.forEach(e=>{
                                sum+=e.count
                            })
                            
                            this.addData3=res.data.map(e=>{
                                // console.log(e.count);
                                let cpnums=fpMap[e.xydm];
                                e.cpnum=Math.floor(this.addData21.cpnum*(e.count/sum));
                                if(cpnums!=undefined){
                                    e.cpnum2=cpnums
                                }else{
                                    e.cpnum2=e.cpnum;
                                }
                                return e
                            })
                        }
                        if(this.addData1.fdj===2){
                            this.hjflag=false;
                            let data=[]
                            let xxcount=0;
                             res.data.forEach(e=>{
                                    xxcount+=e.count;
                                })
                            let arrNum = ['一','二','三','四','五','六','七','八','九','十'];
                            for(let i =0 ;i<this.addData2.dynamic.length;i++){
                                let djdata=this.addData2.dynamic[i];
                                let obj={};
                                obj.cp_dj_id=arrNum[djdata.$index]+'等';
                                obj.xymc='合计';
                                obj.count=xxcount;
                                let fpMap={};
                                if(!this.validatenull(this.cpxxFpMap) && Object.keys(this.cpxxFpMap)[0]!=="0"){
                                    this.cpxxFpMap[djdata.dj].forEach(e=>{  
                                        fpMap[e.xydm]=e.num;
                                    })
                                }
                                // console.log(fpMap);
                                let cpNum=0;
                                res.data.forEach(e=>{
                                    e.cp_dj_id=arrNum[djdata.$index]+'等'
                                    e.dj=djdata.$index;
                                    let data2=JSON.parse(JSON.stringify(e));
                                    data2.cpnum=this.addData1.abl===1?Math.floor(djdata.cpnum*(data2.count/xxcount)):Math.floor(data2.count*djdata.cpnum*0.01);
                                    let cpnums=fpMap[data2.xydm];
                                    if(cpnums!=undefined){
                                        data2.cpnum2=cpnums;
                                        cpNum+=cpnums;
                                    }else{
                                        data2.cpnum2=data2.cpnum;
                                        cpNum+=data2.cpnum;
                                    }
                                    data.push(data2);
                                })
        
                                obj.cpnum=this.addData1.abl===1?djdata.cpnum:Math.floor(obj.count*djdata.cpnum*0.01);
                                obj.cpnum2=cpNum;
                                data.push(obj);
                            };
                           
                            this.addData3=data;
                            let contactDot = 0;
                            // 合并行
                            if(this.addData1.fdj===2){

                                this.addData3.forEach( (item,index) => {
                                    // console.log(item);
                                    if(index===0){
                                        this.spanArr.push(1)
                                    }else{
                                        if(item.cp_dj_id === this.addData3[index-1].cp_dj_id){
                                            this.spanArr[contactDot] += 1;
                                            this.spanArr.push(0)
                                        }else{
                                            contactDot = index
                                            this.spanArr.push(1)
                                        }
                                    }
                                })
                            }                           
                        }
                    })
                    
                }
                 
            },
            // 新增-上一步
            previous(){
                if(this.step>0){
                    this.step--;
                    this.$nextTick(()=>{
                        this.spanArr=this.$options.data().spanArr;
                        this.addData2.cpnum=this.$options.data().addData2.cpnum;
                    })
                }
            },

            
            // 新增弹框取消
            addCancel(){
                this.dialogVisible=false
                this.step=this.$options.data().step
                // 取消后初始化输入的数据
                this.objInit(this.addData1,this.$options.data().addData1)
            },



            // 表格合计
            getSummaries(param){
                 const { columns, data } = param;
                //  console.log(param)
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev*1 + curr*1;
                                } else {
                                    return prev*1;
                                }
                                }, 0);
                            sums[index];
                        } else {
                            // sums[index] = 'N/A';
                            let sum=0;
                            data.forEach(e=>{
                                sum+=e.cpnum2*1
                            })
                            sums[index]=sum*1;
                        }
                        // console.log(sums)
                    });

            return sums;
            },
            // 参评大类级联
            cpdlChange(val,data,callback){
                // console.log(data);
                // this.getSelectDate("/cplb/listByCpdl_id","lbmc","id","cplb_mc",{params:{"cpdl_id":item.value}},"get")
                if (!val.value && !callback) {
                    (data.cpdl_mc = data.cplb_mc = '')
                    return
                } else if (!val.value && callback) {
                    typeof callback === 'function' && callback([])
                }
                this.$http.get('/cplb/listByCpdl_id', {params:{
                        cpdl_id:val.value
                    }}).then(response => {
                        // console.log(response);
                        let result = []
                        response.data.forEach(element => {
                            result.push({
                                label: element.lbmc,
                                value: element.id
                            })
                        })

                        if (callback) {
                            typeof callback === 'function' && callback(result)
                        } else {
                            let column=this.mainTable.table.columns;
                            let index = this.findArray(column,"cplb_mc",'prop');
                            column[index].dicData=result;
                            this.mainTable.table.reloadConditions.cplb_mc = ''
                            // this.$refs.mainTable.setColumnSeting('cplb_mc', 'dicData', result)
                        }
                    })
            },
            // 排序
            sortBy: function(attr,rev){
                //第二个参数没有传递 默认升序排列
                if(rev ==  undefined){
                    rev = 1;
                }else{
                    rev = (rev) ? 1 : -1;
                }
                
                return function(a,b){
                    a = a[attr];
                    b = b[attr];
                    if(a < b){
                        return rev * -1;
                    }
                    if(a > b){
                        return rev * 1;
                    }
                    return 0;
                }
            },
            // 对象初始化
            objInit(obj,init){
                for(let key in obj){
                    delete obj[key];
                }
                // Object.assign(obj,init);
                this.$set(obj,Object.assign(obj,init))

            },

            //下拉框
            getSelectDate(url,label,value,prop,params,method){
                method=method||"post";
                params=params||{};
                let column=this.mainTable.table.columns;
                let index=this.findArray(column,prop,"prop");
                this.$http[method](url,params).then(res=>{
                    // console.log(res);
                    let arrDate=[];
                    res.data.forEach(element=>{
                        arrDate.push({
                            label:element[label],
                            value:element[value]
                        })
                    });
                    column[index].dicData=arrDate;
                console.log(arrDate);

                    // this.$refs.mainTable.setColumnSeting(prop, 'dicData', arrDate)
                })            
            },
           
            // 表格合计样式
            tableRowClassName({row, rowIndex}) {
                if (row.xymc === "合计") {               
                    return 'warning-row';
                }
                    return ""
            }
                
        },
        mounted() {
            this.mainTableReload(),
         

            // 学年下拉框
            this.$http.get("/Xn/queryMap").then(res=>{
                let arrDate=[]; 
                let column=this.addOption1.column;
                let index = this.findArray(column,"xn",'prop');
                res.data.forEach(element=>{
                    arrDate.push({
                        label:element.xnd,
                        value:element.id
                    })
                });
                arrDate=arrDate.sort(this.sortBy('label',false));
                column[index].dicData=arrDate;
                // this.$refs.mainTable.setColumnSeting('xn', 'dicData', arrDate)
            });
            this.$http.get("/Xn/queryMap").then(res=>{
                let arrDate=[]; 
                let column=this.mainTable.table.columns;
                let index = this.findArray(column,"xn",'prop');
                res.data.forEach(element=>{
                    arrDate.push({
                        label:element.xnd,
                        value:element.id
                    })
                });
                arrDate=arrDate.sort(this.sortBy('label',false));
                column[index].dicData=arrDate;
                // this.$refs.mainTable.setColumnSeting('xn', 'dicData', arrDate)
            });
            // 参评大类下拉框
            this.getSelectDate("/cpdl/list","dlmc","id","cpdl_mc",null,"get");
            // 增加弹框的参评大类下拉框
            this.$http.get("/cpdl/list").then(res=>{
                    // console.log(res);
                    let arrDate=[];
                    let column=this.addOption1.column;
                    res.data.forEach(element=>{
                        arrDate.push({
                            label:element.dlmc,
                            value:element.id
                        })
                    });
                    let index = this.findArray(column,"cpdl_id",'prop');
                    column[index].dicData=arrDate;
            });
            
            
            // 新增弹框-资格限定器
            this.$http.get("/limit/getAllLimitInfo").then(res=>{
                let column1=this.addOption2.column;
                let index = this.findArray(column1,"dynamic",'prop');
                let column2=column1[index].children.column;
                let index2 = this.findArray(column2,"zgxdq_id",'prop');
                let column3 = this.addOption21.column;
                let index3 = this.findArray(column3,"zgxdq_id",'prop');
                let data=[]
                res.data.forEach(e=>{
                    data.push({
                        label:e.limitName,
                        value:e.id                      
                    })
                })
                column2[index2].dicData=data;
                column3[index3].dicData=data;
            })
        },
        watch:{
            addData3:{
                handler(newVal,oldVal){
                    this.addData3=newVal;
                }
            },
            deep:true,
            immediate: true
        }
    }
</script>

<style lang="scss">
    .el-dialog__wrapper .el-steps--simple{
            margin-bottom: 20px;
            
    }
    .easyCruds .el-form-item{
        height: 42px;
    }
    .el-table .warning-row {
        background: oldlace;
    }
</style>